export class InputPropertyList{
    accessToken: string;
    envURL?: string;
}